import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { WifiOff } from 'lucide-react';

/** Aviso fixo enquanto o aparelho estiver sem internet */
export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <div role="status" aria-live="polite">
      <AnimatePresence>
        {isOffline && (
          <motion.div
            className="pointer-events-none fixed inset-x-0 top-0 z-[80] flex justify-center px-4 pt-3"
            initial={{ y: -60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -60, opacity: 0 }}
          >
            <div className="pointer-events-auto flex max-w-xl items-center gap-3 rounded-2xl bg-ink px-4 py-3 text-sm text-canvas shadow-elevation-3">
              <WifiOff className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" />
              <span>
                <strong className="font-semibold">Você está sem conexão.</strong> Enviar propostas, salvar e carregar dados
                volta a funcionar quando a internet voltar.
              </span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
